const metatags = {
  homepage: {
    title: 'LaVilla Boutique Hotel',
    description:
      'Prelepi Butik hotel u Starom Gradu Budve sa Mediteranskom i Kineskom kuhinjom',
  },
  restaurant: {
    title: 'Mediterranean, Chinese ans Sushi Cuisine',
    description:
      'Probajte vrhunske primorske specijalitete u LaVilla Restoranu, ili osetite ukus dalekog istoka iz restorana Shanghai',
  },
  offers: {
    title: 'LaVilla specijalne ponude i promocije',
    description:
      'Iznajmie polupodmornicu, jahtu, čamac ili se odmarajte u miru skrivene privatne plaže',
  },
  room: {
    title: 'LaVilla sobe',
    description:
      'Uživajte u predivnom Starom gradu u jednoj od naših ekskluzivnih soba',
  },
};

export default metatags;